import type { ApiEventId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { ApiEvent } from './types/ApiEvent';
import type { ApiUnpublishedEvent } from './types/ApiUnpublishedEvent';

type ApiResponse = {
  data: ApiEvent | ApiUnpublishedEvent;
};

function mapResponse(response: ApiResponse): ApiEvent | ApiUnpublishedEvent {
  return response.data;
}

const endpoint = new FetchEndpoint({
  urlFactory: (eventId: ApiEventId) => `/data/website/events/${eventId}`,
  mapResponse,
});

// Exports

export const listingApiIsomorphicFetchEvent =
  endpoint.createIsomorphicFetchFn();
